import {useCallback, useEffect, useState} from "react";
import { allCountries } from 'country-region-data';
import {Button, DatePicker, InlineStack, Modal, Select, Text, TextField} from "@shopify/polaris";
import {toDate} from "./Dates";

const CountryNameKey = 0;
const CountrySlugKey = 1;
const CountryRegionsKey = 2;

const RegionNameKey = 0;
const RegionSlugKey = 1;

export const CountrySelector = ({value =  '', onChange = () => {}, error, disabled = false}) => {
    const getOptions = () => {
        return allCountries.map((country) => {
            return {
                value: country[CountrySlugKey],
                label: country[CountryNameKey]
            };
        });
    };

    return (<>
        <Select
            placeholder={"- Select Country -"}
            label={"Country"}
            options={getOptions()}
            value={value}
            onChange={onChange}
            error={error}
            disabled={disabled}
        ></Select>
    </>)
}

export const StateSelector = ({value =  '', onChange = () => {}, selectedCountry = '', error, disabled = false}) => {
    const getOptions = () => {
        let regions = [];

        allCountries.forEach((country) => {
            if (country[CountrySlugKey] === selectedCountry) {
                regions = country[CountryRegionsKey];
            }
        });

        return regions.map((region) => {
            return {
                value: region[RegionSlugKey],
                label: region[RegionNameKey]
            };
        });
    };

    return (<>
        <Select
            placeholder={"- Select State -"}
            label={"State"}
            options={getOptions()}
            value={value}
            onChange={onChange}
            error={error}
            disabled={disabled}
        ></Select>
    </>)
}



export function DatePickerSelector({
    startDate,
    endDate,
    onChange,
    buttonLabel,
    modalTitle,
    label,
    allowRange = false,
    multiMonth = false,
    disabled = false,
})
{
    const date = startDate ? new Date(startDate) : new Date();

    const [{month, year}, setDate] = useState({month: date.getMonth(), year: date.getFullYear()});
    const [selectedDates, setSelectedDates] = useState({
        start: new Date(date),
        end: new Date(endDate ?? date),
    });
    const [modalActive, setModalActive] = useState(false)

    const handleMonthChange = useCallback(
        (month, year) => setDate({month, year}),
        [],
    );

    const submit = useCallback(() => {
        onChange(allowRange
            ? selectedDates
            : selectedDates.start
        );

        setModalActive(false);
    }, [selectedDates])

    return <>
        <InlineStack align={'start'} gap={'200'}>
            {!!label && (<Text variant="headingMd" as="div">{label}</Text>)}
            <Text variant="bodyMd" as="span">
                {!!startDate && (toDate(startDate))}
                {!!endDate && allowRange && ('-' + toDate(endDate))}
            </Text>
            <Button size={'slim'} disabled={disabled} onClick={() => setModalActive(true)}>{buttonLabel ?? 'Select Date'}</Button>
        </InlineStack>
        <Modal
            open={!disabled && modalActive}
            onClose={() => setModalActive(false)}
            title={modalTitle ?? 'Select Date'}
            primaryAction={{
                content: 'Submit',
                onAction: submit,
            }}
            secondaryActions={[
                {
                    content: 'Cancel',
                    onAction: () => setModalActive(false),
                },
            ]}
        >
            <Modal.Section>
                <DatePicker
                    month={month}
                    year={year}
                    onChange={setSelectedDates}
                    onMonthChange={handleMonthChange}
                    selected={selectedDates}
                    allowRange={allowRange}
                    multiMonth={multiMonth}
                />
            </Modal.Section>
        </Modal>
    </>;
}


export function ModalTextInput({
   value,
   onChange,
   label,
   disabled = false,
})
{
    const [modalActive, setModalActive] = useState(false)
    const [internalValue, setInternalValue] = useState(value);

    const submit = useCallback(() => {
        onChange(internalValue);
        setModalActive(false);
    }, [internalValue]);

    return <>
        <Button
            size={'slim'}
            disabled={disabled}
            onClick={() => setModalActive(true)}
            tone={'success'}
        >
            {value && value.length > 0 ? 'Edit Notes' : 'Add Notes'}
        </Button>
        <Modal
            open={!disabled && modalActive}
            onClose={() => setModalActive(false)}
            title={value && value.length > 0 ? 'Edit Notes' : 'Add Notes'}
            primaryAction={{
                content: 'Save',
                onAction: submit,
            }}
            secondaryActions={[
                {
                    content: 'Cancel',
                    onAction: () => setModalActive(false),
                },
            ]}
        >
            <Modal.Section>
                <TextField label={label}  multiline={4} autoComplete={"off"} value={internalValue} onChange={setInternalValue} disabled={disabled} />
            </Modal.Section>
        </Modal>
    </>;
}
